module.exports = __webpack_public_path__ + "media/images/default-meeting-image-10038ef76542eebb2e266b8e5f2c099b.png";